module.exports = __webpack_public_path__ + "static/media/icon_person.24553066.svg";